  export const maskKey = (key) => {
    if (!key) return "-";
    const visibleChars = 5;
    if (key.length <= 2 * visibleChars) return key;

    const firstPart = key.slice(0, visibleChars);
    const lastPart = key.slice(-visibleChars);
    const maskedLength = key.length - 2 * visibleChars;

    return `${firstPart}${'.'.repeat(maskedLength)}${lastPart}`;
  };